import util from "../BsUtil"
import bsGetEnv from "../BsGetEnv";
// import DIDA_SDK from "../bs-didasdk"

function getApplationLo() {
    return new Promise((resolve,reject)=>{
        if(!window.DIDASDK){
            console.log('DIDASDK没有引入！');
            resolve({});
            return;
        }
        try {
            let timer = setTimeout(()=>{
                resolve({});
                clearTimeout(timer);
                timer = null;
            },3000);
            window.DIDASDK.invoke('getLocation', {}, res => {
                clearTimeout(timer);
                if (res) {
                    const obj = JSON.parse(res) || {}
                    resolve({
                        long : obj.lng ,
                        lat : obj.lat ,
                        address: obj.address
                    });
                } else {
                    resolve({});
                }
            })
        } catch (error) {
            resolve({});
        }
    })
}
let longitude, latitude, daddress;
async function getLL(){
    if(longitude && latitude){
        return {latitude, longitude}
    }
    let defaultlongitude = '116.403847'
    let defaultlatitude = '39.915526'
    let defaultaddress = '北京';
    if (bsGetEnv.inApplication) {
        // app 内
        let {long, lat, address} = await getApplationLo();
        longitude = long ;
        latitude = lat;
        daddress = address;
    } else {
        // 非app，小程序一进入跳下载页，不用过多判断
        latitude = util.queryString('lat');
        longitude = util.queryString('lon');
        daddress = util.queryString('address') || '';
    }
    return {latitude: latitude || defaultlatitude  , longitude: longitude || defaultlongitude, address: daddress || defaultaddress };
}

let Location = getLL()
export default function(flag){
    if(flag){
        Location = getLL()
    }
    return Location
};
